<template>
  <div v-if="confirm" class="q-pa-md q-gutter-sm">
    <q-dialog v-model="confirm" persistent transition-show="scale" transition-hide="scale">
      <q-card style="width: 300px">
        <div class="alert-box">
          <div class="alert-title">ALERT!!</div>
          <div class="alert-content">
            <div class="alert-text" style="text-align:center">Are you sure to delete record?</div>
            <div class="alert-actions">
              <q-btn flat @click="reset">CANCEL</q-btn>
              <q-btn flat :loading="loading" label="OK" @click="remove">
                <template v-slot:loading>
                  <q-spinner-facebook />
                </template>
              </q-btn>
            </div>
          </div>
        </div>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import axios from "../axios/index";
export default {
  data() {
    return {
      loading: false
    };
  },
  methods: {
    reset() {
      this.confirm = false;
      this.selectedMillage = {};
    },
    async remove() {
      try {
        this.loading = true;
        await axios.delete(`vehicle-mileage-record/${this.selectedMillage.id}`);
        this.$store.commit("millage/REMOVE_MILLAGE", this.selectedMillage);
        this.selectedMillage = {};
        this.confirm = false;
        this.$q.notify({
          message: "Mileage deleted.",
          timeout: 250,
          position: "top-right",
          progress: true,
          type: "positive"
        });
      } catch (error) {
        this.$q.notify({
          message: "We can not delete mileage.Something wrong.",
          timeout: 250,
          position: "top-right",
          progress: true,
          type: "negative"
        });
      } finally {
        this.loading = false;
      }
    }
  },
  computed: {
    confirm: {
      get() {
        return this.$store.state.millage.confirm;
      },
      set(val) {
        this.$store.commit("millage/SET_CONFIRM", val);
      }
    },
    selectedMillage: {
      get() {
        return this.$store.state.millage.selectedMillage;
      },
      set(val) {
        this.$store.commit("millage/SET_SELECTED_MILLAGE", val);
      }
    }
  }
};
</script>
